// 首页数据（演示内容）。数据源接入真实接口后，请替换并删除本文件。

export const heroStats = [
  { label: '今日上榜视频', value: '1,286', unit: '条' },
  { label: '覆盖内容分区', value: '12', unit: '类' },
  { label: '24小时总播放', value: '4.7', unit: '亿' },
  { label: '榜单更新频率', value: '30', unit: '分钟' },
];

export const quickTags = ['热榜速览', '爆款内容', '经典节目', '编辑精选', '数据洞察', '追热门指南'];

export const filterCategories = ['全部', '美食', '纪录片', '生活', '三农', '影视解说', '旅行', '知识'];

export const rankingVideos = [
  {
    rank: 1,
    title: '《山海寻味记》第12集：凌晨四点的海边码头，第一网鲜货上岸',
    author: '山海食记',
    category: '美食',
    plays: '2,341万',
    duration: '18:24',
    likes: '96.2万',
    trend: 'up',
    change: '+3',
    summary: '跟拍渔港从深夜到天亮的完整链条，从分拣、称重到家常做法，一镜到底记录海味上桌的全过程。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20video%20thumbnail%20of%20a%20bustling%20seaside%20fish%20harbor%20at%20dawn%20with%20fresh%20seafood%20crates%20and%20glowing%20harbor%20lamps%2C%20soft%20orange%20morning%20light%2C%20shallow%20depth%20of%20field%2C%20documentary%20food%20photography%20style%2C%20rich%20and%20saturated%20warm%20tones&width=640&height=360&seq=xg-rank-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '深山守林人：一个人在海拔三千米的林场度过了第七个冬天',
    author: '荒野纪录',
    category: '纪录片',
    plays: '1,876万',
    duration: '26:40',
    likes: '74.5万',
    trend: 'up',
    change: '+5',
    summary: '用四季素材串起守林人的日常：巡山、防火、修补瞭望塔，以及那只陪了他六年的土狗。',
    cover: 'https://readdy.ai/api/search-image?query=Quiet%20cinematic%20thumbnail%20of%20a%20lone%20forest%20ranger%20walking%20a%20snowy%20mountain%20ridge%20above%20a%20misty%20pine%20forest%2C%20soft%20cold%20light%20with%20warm%20sun%20flare%2C%20documentary%20photography%20style%2C%20muted%20natural%20palette%20with%20earthy%20tones&width=640&height=360&seq=xg-rank-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '梯田秋收全记录：八百级田埂上的稻谷，怎么被一担担挑下山',
    author: '乡野农事',
    category: '三农',
    plays: '1,654万',
    duration: '21:08',
    likes: '68.9万',
    trend: 'down',
    change: '-1',
    summary: '从开镰到晒谷，完整呈现山地稻作的节奏，也记录了村民合伙收粮的默契。',
    cover: 'https://readdy.ai/api/search-image?query=Golden%20autumn%20rice%20terraces%20on%20a%20steep%20mountain%20slope%20with%20framers%20carrying%20baskets%2C%20warm%20amber%20harvest%20light%2C%20wide%20cinematic%20composition%2C%20rural%20documentary%20photography%20style%2C%20rich%20golden%20and%20green%20tones&width=640&height=360&seq=xg-rank-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '一口气看懂悬疑片《回声》：三个时间线到底怎么拼在一起',
    author: '影迷拆解站',
    category: '影视解说',
    plays: '1,502万',
    duration: '14:52',
    likes: '63.1万',
    trend: 'up',
    change: '+8',
    summary: '用时间轴动画还原三线叙事，逐帧标注伏笔与反转，附上导演访谈里的关键提示。',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20thumbnail%20of%20a%20dim%20theater%20screen%20with%20abstract%20timeline%20graphics%20and%20film%20reel%20details%2C%20teal%20and%20amber%20rim%20light%2C%20high%20contrast%20editorial%20style%2C%20artistic%20and%20stylized%2C%20deep%20shadow%20tones&width=640&height=360&seq=xg-rank-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '三十年老房改造第4期：把一间暗厨房改成双向采光的中岛',
    author: '住家手记',
    category: '生活',
    plays: '1,388万',
    duration: '16:37',
    likes: '57.4万',
    trend: 'up',
    change: '+2',
    summary: '从拆墙、走水到中岛落成，完整记录预算、材料与踩坑点，附赠收纳尺寸清单。',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20renovated%20kitchen%20with%20a%20wooden%20island%20and%20double%20windows%20letting%20in%20soft%20daylight%2C%20warm%20cream%20and%20oak%20tones%2C%20clean%20lifestyle%20interior%20photography%2C%20minimal%20and%20airy%20composition&width=640&height=360&seq=xg-rank-05&orientation=landscape',
  },
  {
    rank: 6,
    title: '川西环线自驾第七天：翻过垭口，云海在脚下翻开',
    author: '路上放映厅',
    category: '旅行',
    plays: '1,240万',
    duration: '19:15',
    likes: '52.8万',
    trend: 'down',
    change: '-2',
    summary: '全程路书与住宿经验一次讲清，镜头里是实拍的日出云海、草甸和山间牧民点。',
    cover: 'https://readdy.ai/api/search-image?query=Sweeping%20aerial%20thumbnail%20of%20a%20winding%20mountain%20road%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20warm%20golden%20light%20spilling%20over%20blue%20ridges%2C%20cinematic%20travel%20photography%2C%20epic%20wide%20composition&width=640&height=360&seq=xg-rank-06&orientation=landscape',
  },
  {
    rank: 7,
    title: '宇宙到底有多大？从地球出发，把尺度拉到可观测边界',
    author: '硬核常识局',
    category: '知识',
    plays: '1,176万',
    duration: '12:48',
    likes: '49.3万',
    trend: 'up',
    change: '+6',
    summary: '用可缩放的尺度动画逐级放大，每个层级配一个直观类比，零基础也能看懂。',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20space%20thumbnail%20with%20glowing%20star%20clusters%20and%20a%20luminous%20galaxy%20core%20on%20deep%20indigo%20backdrop%2C%20warm%20amber%20and%20violet%20accents%2C%20clean%20scientific%20illustration%20style%2C%20highly%20detailed&width=640&height=360&seq=xg-rank-07&orientation=landscape',
  },
  {
    rank: 8,
    title: '夜市摆摊二十年：一碗汤粉的十二种浇头是怎么配出来的',
    author: '街角味道',
    category: '美食',
    plays: '1,092万',
    duration: '13:26',
    likes: '45.7万',
    trend: 'up',
    change: '+1',
    summary: '走进老摊的后厨，看老板备料、熬汤与出餐的完整流程，还有他的选客小规矩。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20night%20market%20food%20stall%20thumbnail%20with%20a%20steaming%20bowl%20of%20noodles%20and%20colorful%20toppings%2C%20warm%20lantern%20glow%2C%20rich%20appetizing%20food%20photography%2C%20shallow%20depth%20of%20field%20and%20bokeh&width=640&height=360&seq=xg-rank-08&orientation=landscape',
  },
  {
    rank: 9,
    title: '城市夜行者：凌晨两点还在工作的人，都在做什么',
    author: '人间观察室',
    category: '纪录片',
    plays: '1,024万',
    duration: '23:11',
    likes: '43.0万',
    trend: 'down',
    change: '-3',
    summary: '跟随代驾、便利店店长与急诊护士完成一整夜的班次，记录城市另一种作息。',
    cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20urban%20night%20thumbnail%20with%20a%20lone%20street%20vendor%20under%20warm%20streetlights%20and%20wet%20reflective%20pavement%2C%20soft%20amber%20and%20dark%20teal%20tones%2C%20cinematic%20documentary%20photography&width=640&height=360&seq=xg-rank-09&orientation=landscape',
  },
  {
    rank: 10,
    title: '把爷爷的旧收音机修好：拆解、清灰与换电容的全程记录',
    author: '手作修理铺',
    category: '生活',
    plays: '968万',
    duration: '15:44',
    likes: '40.2万',
    trend: 'up',
    change: '+4',
    summary: '从拆机到通电测试，边修边讲原理，最后放了一段老电台的声音作为收尾。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20workshop%20thumbnail%20showing%20a%20vintage%20wooden%20radio%20disassembled%20on%20a%20workbench%20with%20small%20tools%20and%20components%2C%20soft%20lamp%20light%2C%20detailed%20macro%20craft%20photography%2C%20earthy%20tones&width=640&height=360&seq=xg-rank-10&orientation=landscape',
  },
  {
    rank: 11,
    title: '果园采摘季：一上午摘三千斤苹果，分拣线是怎么运转的',
    author: '田埂新农人',
    category: '三农',
    plays: '902万',
    duration: '17:02',
    likes: '37.6万',
    trend: 'up',
    change: '+2',
    summary: '从枝头采摘到清洗分级，展示果园合作社的流水线，也聊了今年的收购价。',
    cover: 'https://readdy.ai/api/search-image?query=Sunny%20orchard%20thumbnail%20with%20red%20apples%20in%20wooden%20crates%20and%20workers%20picking%20fruit%20among%20green%20trees%2C%20bright%20warm%20daylight%2C%20vibrant%20agricultural%20documentary%20photography%2C%20fresh%20natural%20tones&width=640&height=360&seq=xg-rank-11&orientation=landscape',
  },
  {
    rank: 12,
    title: '海岛慢旅行：住进渔村第七天，赶海、看落日与一顿家宴',
    author: '慢速旅行团',
    category: '旅行',
    plays: '856万',
    duration: '20:33',
    likes: '34.9万',
    trend: 'down',
    change: '-1',
    summary: '淡季海岛的真实体验：民宿价格、交通方式与赶海时间表，全都如实记录。',
    cover: 'https://readdy.ai/api/search-image?query=Relaxing%20seaside%20thumbnail%20of%20a%20quiet%20fishing%20village%20harbor%20at%20sunset%20with%20small%20boats%20and%20warm%20reflections%20on%20water%2C%20soft%20peach%20and%20teal%20tones%2C%20serene%20cinematic%20travel%20photography&width=640&height=360&seq=xg-rank-12&orientation=landscape',
  },
];

export const viralVideos = [
  {
    title: '一条视频带你走完老街改造的三年',
    author: '城记影像',
    category: '生活',
    plays: '1,864万',
    duration: '11:20',
    badge: '本周爆款',
    summary: '用延时与航拍对照展示老街三年间的变化，还采访了坚持留下的十二家老店。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20thumbnail%20of%20a%20renovated%20old%20town%20street%20with%20red%20lanterns%20and%20traditional%20shops%20at%20dusk%2C%20glowing%20storefronts%2C%20editorial%20urban%20photography%2C%20rich%20amber%20and%20teal%20tones&width=720&height=400&seq=xg-viral-01&orientation=landscape',
  },
  {
    title: '零基础看懂一道家常硬菜：红烧全过程逐帧拆解',
    author: '厨房说明书',
    category: '美食',
    plays: '1,522万',
    duration: '09:48',
    badge: '飙升最快',
    summary: '把火候、糖色与收汁拆成可复制的步骤，每个关键节点都会定格标注时间和状态。',
    cover: 'https://readdy.ai/api/search-image?query=Appetizing%20close%20up%20thumbnail%20of%20glossy%20braised%20pork%20in%20a%20dark%20clay%20pot%20with%20steam%20and%20fresh%20scallions%2C%20warm%20rich%20brown%20sauce%2C%20professional%20food%20photography%2C%20cozy%20kitchen%20ambience&width=720&height=400&seq=xg-viral-02&orientation=landscape',
  },
  {
    title: '他把废弃厂房改成了社区图书馆',
    author: '人间观察室',
    category: '纪录片',
    plays: '1,408万',
    duration: '22:05',
    badge: '口碑高分',
    summary: '记录一位退休教师和志愿者团队，用两年时间让旧厂房重新亮起灯的过程。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20industrial%20community%20library%20inside%20a%20renovated%20warehouse%20with%20tall%20windows%20and%20warm%20reading%20lamps%2C%20bookshelves%20and%20plants%2C%20warm%20documentary%20interior%20photography&width=720&height=400&seq=xg-viral-03&orientation=landscape',
  },
  {
    title: '三天徒步穿越草甸：海拔与装备一次讲清',
    author: '路上放映厅',
    category: '旅行',
    plays: '1,266万',
    duration: '18:52',
    badge: '收藏最多',
    summary: '完整标注沿途补给点与露营位置，附上装备清单和体力分配建议，适合第一次尝试。',
    cover: 'https://readdy.ai/api/search-image?query=Scenic%20alpine%20meadow%20hiking%20thumbnail%20with%20a%20small%20tent%20and%20wildflowers%20under%20towering%20peaks%2C%20warm%20golden%20hour%20light%2C%20cinematic%20outdoor%20travel%20photography&width=720&height=400&seq=xg-viral-04&orientation=landscape',
  },
];

export const classicShows = [
  {
    title: '《山海寻味记》',
    genre: '美食纪录片',
    episodes: '已更新 46 集',
    rating: '9.4',
    desc: '一集一地，走访渔港、山村与边境小镇，用一桌饭讲透一个地方的风土与人情。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20food%20documentary%20poster%20style%20thumbnail%20with%20rustic%20table%20dishes%20and%20soft%20lantern%20light%2C%20steaming%20bowls%20and%20fresh%20ingredients%2C%20rich%20earthy%20tones%2C%20editorial%20culinary%20photography&width=560&height=320&seq=xg-classic-01&orientation=landscape',
  },
  {
    title: '《人间观察室》',
    genre: '社会纪录片',
    episodes: '已更新 28 集',
    rating: '9.1',
    desc: '把镜头对准普通人的一天，记录不同职业与生活状态里真实、克制的细节。',
    cover: 'https://readdy.ai/api/search-image?query=Candid%20documentary%20thumbnail%20of%20ordinary%20people%20in%20a%20city%20street%20with%20soft%20natural%20light%20and%20gentle%20bokeh%2C%20observational%20photography%2C%20muted%20warm%20tones&width=560&height=320&seq=xg-classic-02&orientation=landscape',
  },
  {
    title: '《硬核常识局》',
    genre: '知识科普',
    episodes: '已更新 60 集',
    rating: '8.9',
    desc: '每期把一个复杂问题拆成可理解的层级，配动画与类比，适合碎片时间补常识。',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20educational%20thumbnail%20with%20abstract%20glowing%20diagrams%20and%20geometric%20shapes%20on%20a%20dark%20warm%20gradient%20background%2C%20modern%20science%20illustration%20style%2C%20amber%20and%20teal%20accents&width=560&height=320&seq=xg-classic-03&orientation=landscape',
  },
  {
    title: '《住家手记》',
    genre: '生活家居',
    episodes: '已更新 34 集',
    rating: '8.7',
    desc: '跟拍真实家庭的改造与收纳，讲清预算、动线与材料选择，落地性强、可照抄。',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20minimal%20home%20interior%20thumbnail%20with%20wooden%20furniture%20and%20soft%20daylight%20through%20sheer%20curtains%2C%20calm%20warm%20neutral%20tones%2C%20scandinavian%20lifestyle%20photography&width=560&height=320&seq=xg-classic-04&orientation=landscape',
  },
];

export const editorPicks = [
  {
    title: '被低估的五部公路纪录片，值得一个完整的晚上',
    editor: '编辑 林砚',
    tag: '影单',
    desc: '避开热门榜单的喧闹，挑出五部关于出发与归途的片子，附上每部最打动人的一个镜头说明。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20road%20trip%20thumbnail%20with%20an%20open%20highway%20cutting%20through%20golden%20fields%20at%20sunset%2C%20warm%20dusty%20light%2C%20film%20still%20composition%2C%20muted%20amber%20and%20green%20tones&width=560&height=320&seq=xg-pick-01&orientation=landscape',
  },
  {
    title: '深夜厨房特辑：那些只开到凌晨的小店',
    editor: '编辑 周也',
    tag: '专题',
    desc: '精选六家营业到凌晨的小馆，从一碗汤到一份炒饭，记录深夜食客们各自的理由。',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20late%20night%20food%20stall%20thumbnail%20with%20warm%20hanging%20bulbs%20and%20steaming%20dishes%2C%20rainy%20street%20bokeh%20in%20background%2C%20rich%20amber%20tones%2C%20moody%20food%20photography&width=560&height=320&seq=xg-pick-02&orientation=landscape',
  },
  {
    title: '给忙碌的人：二十分钟能看完的轻纪录片清单',
    editor: '编辑 苏晓',
    tag: '清单',
    desc: '把时长控制在二十分钟以内，适合通勤或午饭时间，每部都能带来一点新的看法。',
    cover: 'https://readdy.ai/api/search-image?query=Calm%20minimal%20thumbnail%20with%20a%20notebook%20a%20cup%20of%20coffee%20and%20headphones%20on%20a%20wooden%20desk%2C%20soft%20morning%20light%2C%20clean%20lifestyle%20flat%20lay%20photography%2C%20warm%20neutral%20tones&width=560&height=320&seq=xg-pick-03&orientation=landscape',
  },
  {
    title: '手艺人的一天：六段关于坚持与耐心的记录',
    editor: '编辑 陈默',
    tag: '专题',
    desc: '从修表、制陶到修古籍，六位手艺人的日常，节奏很慢，但看完心里很安静。',
    cover: 'https://readdy.ai/api/search-image?query=Artisan%20workshop%20thumbnail%20with%20hands%20crafting%20pottery%20on%20a%20spinning%20wheel%20and%20small%20tools%20beside%2C%20warm%20soft%20lamp%20light%2C%20tactile%20craft%20photography%2C%20earthy%20clay%20tones&width=560&height=320&seq=xg-pick-04&orientation=landscape',
  },
];

export const trendInsights = [
  { label: '美食', share: 92, note: '深夜档与家常教程双高，晚间 20:00—23:00 为播放峰值。' },
  { label: '纪录片', share: 78, note: '长视频完播率领先，用户更愿意一次看完 20 分钟以上内容。' },
  { label: '生活', share: 71, note: '改造、收纳与修理类内容收藏量突出，适合做成系列。' },
  { label: '三农', share: 63, note: '秋收与采摘题材季节性明显，集中在 9—11 月增长。' },
  { label: '旅行', share: 58, note: '攻略型内容互动高，路书与预算明细最受关注。' },
  { label: '知识', share: 54, note: '科普短片增速稳定，二十分钟以内的讲解更易传播。' },
];

export const guideSteps = [
  {
    step: '01',
    title: '先看榜单，锁定方向',
    desc: '进入本页榜单区，用顶部标签按分区筛选，先确定自己今天想看的是美食、纪录片还是旅行，避免漫无目的地刷。',
  },
  {
    step: '02',
    title: '关注趋势标记，判断热度',
    desc: '榜单条目上的上箭头与名次变化代表近期热度走向，标记为上升的内容通常处在讨论高峰期，适合追新鲜。',
  },
  {
    step: '03',
    title: '用经典节目补齐口碑片单',
    desc: '如果只想看稳稳的优质内容，直接从口碑节目区挑一部系列片，按集数顺序补，体验更连贯。',
  },
  {
    step: '04',
    title: '收藏编辑精选，节省挑选时间',
    desc: '编辑精选按主题整理成影单与专题，适合时间有限、不想逐条试错的人，一次看完整组推荐即可。',
  },
  {
    step: '05',
    title: '结合数据洞察安排观看时间',
    desc: '数据洞察区展示各分区热度分布，配合自己的作息，把长纪录片放在整块时间，短片留给碎片时间。',
  },
];

export const faqs = [
  {
    q: '这个页面的榜单数据是实时的吗？',
    a: '本页为内容导览演示页，榜单与播放数据均为示例内容，用于展示页面结构与信息组织方式。接入真实数据源后，榜单可按设定的间隔自动刷新。',
  },
  {
    q: '为什么同一分区里既有长片也有短片？',
    a: '分区按内容题材划分，不按时长划分。我们在每个条目上都标注了时长与简介，方便你根据当前可支配的时间挑选合适的内容。',
  },
  {
    q: '榜单上的名次变化是怎么理解的？',
    a: '名次变化表示该内容在近期对比上一周期的排名升降。上升代表关注度走高，下降代表热度回落，可作为是否值得追的一个参考。',
  },
  {
    q: '编辑精选和热门榜单有什么区别？',
    a: '热门榜单反映整体播放与讨论热度，偏大众流行；编辑精选由人工按主题挑选，偏向有额外看点或适合成组观看的内容，两者互补。',
  },
  {
    q: '在手机上看这些密集内容方便吗？',
    a: '页面已针对小屏做适配，榜单与卡片会自动改为纵向排列，字号与间距同步调整，手机上同样可以流畅浏览和筛选。',
  },
];